import m from "./ghl-ui.es1157.js";
const h = (e) => {
  const {
    heightSmall: o,
    heightMedium: t,
    heightLarge: n,
    borderRadius: r
  } = e;
  return {
    color: "#eee",
    colorEnd: "#ddd",
    borderRadius: r,
    heightSmall: o,
    heightMedium: t,
    heightLarge: n
  };
}, c = {
  name: "Skeleton",
  common: m,
  self: h
};
export {
  c as skeletonLight
};
